<template>
  <ui-modal
    :modal-show="+$route.query.form === typeId"
    :modal-size="modalSize ? modalSize : (isLong ? 'modal-main--long' : 'modal-main--short')"
    @close="closeModal"
  >
    <template #title>
      {{ formData?.name }}
    </template>
    <template v-if="isCreated" #body>
      <h3>Ваша заявка отправлена</h3>
      <div class="input-group">
        {{ $config?.app?.forms?.successText?.[typeId] }}
      </div>
      <div class="modal-buttons">
        <button class="btn btn--full btn--grey" @click="closeModal">
          Закрыть
        </button>
      </div>
    </template>
    <template v-else-if="didFormLoad" #body>
      <div class="columns">
        <div
          v-for="(field, index) of fields"
          :key="field.id"
          :class="[
            field.formParamType.code !== 'for_how_long' &&
              field.formParamType.code !== 'loan_amount' &&
              field.formParamType.code !== 'type_of_card'
              ? 'column'
              : '',
            field.formParamType.code === 'for_how_long' ||
              field.formParamType.code === 'loan_amount' ||
              field.formParamType.code === 'type_of_card'
              ? ''
              : field.formParamType.code !== 'phone' &&
                field.formParamType.code !== 'email'
                ? 'col-12'
                : isLong || modalSize && modalSize !== 'modal-main--short'
                  ? 'col-6 sm-col-12'
                  : 'col-12'
          ]"
        >
          <p
            v-if="isCreditOfficeField(field)"
            class="credit-office-notice"
          >
            Для оформления заявки необходима личная явка в офис для передачи пакета документов
          </p>
          <ui-input
            v-if="field.formParamType.code !== 'for_how_long' &&
              field.formParamType.code !== 'loan_amount' &&
              field.formParamType.code !== 'type_of_card' &&
              field.formParamType.params.type !== 'radio' &&
              field.formParamType.params.type !== 'select'"
            :key="field.formParamType.code"
            :required="field.formParamType.params.required"
            :value="newForm.params[index].value"
            :dataset="field.formParamType.code"
            :title="field.formParamType.name"
            :placeholder="fieldPlaceholder(field, 'Введите данные')"
            :code="field.formParamType.code"
            :mask-mutation="field.formParamType.params.type === 'number' ? 'inn' : ''"
            :mask="field.formParamType.code === 'fio'
              ? {
                placeholder: 'Фамилия Имя Отчество',
                delimiter: ' '
              }
              : undefined
            "
            :mode="field.formParamType.code === 'phone' || field.formParamType.params.type === 'number'
              ? 'numeric'
              : ''
            "
            :trigger-validate="triggerValidate"
            @onTriggerValide="onTriggerValide"
            @onChange="onChange({ field, ...$event })"
          />
          <ui-checkbox
            v-else-if="field.formParamType.params.type === 'radio'"
            :value="newForm.params[index].value === 'Да'"
            :trigger-validate="triggerValidate"
            :required="field.formParamType.params.required"
            :validator="field.formParamType.code"
            @onToggle="onChange({
              field,
              value: `${$event.value === true ? 'Да' : 'Нет'}`,
              valide: $event.value,
              code: field.formParamType.code
            })"
            @onTriggerValide="onTriggerValide"
          >
            {{ field.formParamType.name }}
          </ui-checkbox>
          <ui-select
            v-else-if="field.formParamType.code !== 'files' &&
              field.formParamType.params.type === 'select' &&
              field?.formParamType?.code !== 'product_list_custom'
            "
            ref="address"
            :code="field.formParamType.code"
            :option="
              field?.formParamType?.code !== 'product_list' ? {
                address: {
                  city: newForm.params[index].value,
                  value: newForm.params[index].value
                }
              }
              : compOption(field, index)
            "
            :options="
              !productList?.length
                ? field.formParamType.params.options?.map(option => ({ code: option }))
                : productList?.map(product => ({ code: product?.name || product?.fields?.title?.value }))
            "
            :required="field.formParamType.params.required"
            :title="field.formParamType.name"
            :placeholder="fieldPlaceholder(
              field,
              field?.formParamType?.code !== 'product_list' ? 'Введите город' : 'Выберите из списка'
            )"
            :delivery-method="field?.formParamType?.code === 'product_list' ? undefined : 'pickup'"
            :not-found-msg="field?.formParamType?.code === 'product_list' ? 'Пусто' : 'Не найдено ни одного адреса'"
            :options-field-path="field?.formParamType?.code === 'product_list' ? 'code' : 'unrestrictedValue'"
            :option-field-path="field?.formParamType?.code === 'product_list' ? 'code' : 'address.value'"
            :fetch="field?.formParamType?.code !== 'product_list' ? $dadata.fetchCities : undefined"
            :trigger-validate="triggerValidate"
            :static-class="field?.formParamType?.code !== 'product_list' ? '' : 'select'"
            @onTriggerValide="onTriggerValide"
            @onSelect="field?.formParamType?.code !== 'product_list'
              ? onChange({
                field,
                ...$event,
                code: field.formParamType.code,
                value: $event?.shipping?.address?.value
              })
              : () => {}"
            @setOption="onChange({
              field,
              valide: !!$event?.option,
              code: field.formParamType.code,
              value: $event?.option
            })"
          />
          <ui-select
            v-else-if="field.formParamType.code !== 'files' &&
              field.formParamType.params.type === 'select' &&
              field?.formParamType?.code === 'product_list_custom'
            "
            ref="address"
            :option="compOption(field, index)"
            :options="field.formParamType.params.options?.map(option => ({ code: option }))"
            :title="field.formParamType.name"
            :placeholder="fieldPlaceholder(field, 'Выберите из списка')"
            :required="field.formParamType.params.required"
            not-found-msg="Пусто"
            options-field-path="code"
            option-field-path="code"
            :fetch="undefined"
            :custom-validate="{ option: customValidate }"
            :trigger-validate="triggerValidate"
            :code="field.formParamType.code"
            static-class="select"
            @onTriggerValide="onTriggerValide"
            @onSelect="() => {}"
            @setOption="onChange({
              field,
              valide: !!$event?.option,
              code: field.formParamType.code,
              value: $event?.option
            })"
          />
          <ui-files-uploader
            v-else-if="field.formParamType.code !== 'for_how_long' &&
              field.formParamType.code !== 'loan_amount' &&
              field.formParamType.code !== 'type_of_card'"
            :files="filesArr"
            :available-image-extensions="availableImageExtensions"
            :available-video-extensions="availableVideoExtensions"
            :available-file-extensions="availableFileExtensions"
            :required="field.formParamType.params.required"
            :type-of-files="filesWithTypes"
            @removeFile="removeFiles"
            @uploadFile="handleFileUploaad"
          />
        </div>
        <imask-warning key="phone" style="margin-top: 20px" class="column" />
        <div class="column" style="font-size: 14px; margin-top: 10px; line-height: 16px;">
          <!-- !!! -->
          <a target="_blank" href="https://s3.euroalliance.ru/uploads/pages/e1340fe9cd318696215582bffca777a1/0aa05e8c045fefb6242e8ed2848c159a.pdf">
            Политика обработки и обеспечения безопасности персональных данных
          </a>
        </div>
      </div>
      <div class="modal-buttons">
        <ui-button
          :is-loading="isLoading"
          :class-name="'btn--full'"
          @click="onSubmit()"
        >
          Отправить
        </ui-button>
      </div>
    </template>
  </ui-modal>
</template>

<script>
import { mixins } from 'cms3-shop-module-ts'
import CryptoJS from 'crypto-js'
import UiFilesUploader from '../ui/common/ui-files-uploader/index.vue'

export default {
  name: 'FormModal',
  components: {
    UiFilesUploader
  },
  mixins: [mixins.form],
  inject: ['layoutProvider', 'globalFormProvider'],
  props: {
    modalSize: {
      type: String,
      default: () => ''
    },

    productList: {
      type: Array,
      default: () => []
    },

    /**
     * * Тип формы
     */
    typeId: {
      type: Number,
      default: 0
    },

    loanAmount: {
      type: Number,
      default: 0
    },

    loanTerm: {
      type: Number,
      default: 0
    },

    typeOfCard: {
      type: String,
      default: () => ''
    },

    isLong: {
      type: Boolean,
      required: false,
      default: false
    },

    formDefault: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      fileFullData: [],
      emailData: {
        to: '',
        subject: '',
        text: '',
        html: ''
      },
      filesWithTypes: {},
      filesArr: [],
      secondPartOfMail: '',
      thirdPartOfMail: `
        <table style="width: 100%; border: none; background-color: #fff; margin: 0; padding: 0; border-collapse: collapse;">
          <tbody>
              <tr>
                <td style="padding: 36px; background-color: #31509A; border-radius: 15px;">
                    <table style="width: 100%; border: none; margin: 0; padding: 0; border-collapse: collapse;">
                      <tbody>
                          <tr>
                            <td style="padding: 0; text-align: center">
                                <p style="font-family: 'Inter Tight', Arial, sans-serif; font-size: 26px; line-height: 30px; text-align:center;color: #fff; margin: 0; padding: 0">
                                  8-800-700-92-22
                                </p>
                                <p style="font-family: 'Inter Tight', Arial, sans-serif; font-size: 12px; line-height: 20px; text-align:center;color: #fff; margin: 0; padding: 0">
                                  Единый бесплатный номер по России
                                </p>
                            </td>
                          </tr>
                      </tbody>
                    </table>
                </td>
              </tr>
          </tbody>
        </table>`
    }
  },
  computed: {
    providedFormDefault () {
      return this.layoutProvider?.formDefault
    },
    compOption () {
      return (field, index) => ({
        code: this.newForm.params[index].value || (this.shouldUseCreditDefault(field)
          ? this.formDefault || this.typeOfCard || this.providedFormDefault
          : '')
      })
    },
    firstPartOfMail () {
      return `
        <table style="width: 640px; margin: 0 auto; border: none; padding: 0; background-color: #fff; border-collapse: collapse;">
            <tbody>
               <tr>
                  <td style="padding: 20px;">
                     <!--header -->
                     <table style="width: 100%; border: none; background-color: #fff; margin: 0; padding: 0; border-collapse: collapse;">
                        <tbody>
                           <tr>
                              <td style="padding: 20px 0 40px; border-bottom: 1px solid #31509A;">
                                 <table style="width: 100%; border: none; margin: 0; padding: 0; border-collapse: collapse;">
                                    <tbody>
                                       <tr>
                                          <td style="padding: 0; text-align: center">
                                             <img src="${this.$config.S3_DOMAIN}/icons/logotype.png" alt="" width="154" height="40" style="display:block; margin: 0 auto;">
                                          </td>
                                       </tr>
                                    </tbody>
                                 </table>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                     
                     <!-- Existing content -->
                    <table style="width: 100%; border: none; margin: 0 0 40px; padding: 0; border-collapse: collapse;">
              <tbody>
                <tr>
                    <td style="padding: 0; text-align: left;">
                      <p style="font-family: 'Inter Tight', Ubuntu, Helvetica, Arial, sans-serif; font-size: 24px; line-height: 30px; font-weight: bold; text-align: center; color: #000; margin: 0 0 20px; padding: 0">
                          Поступила новая заявка с сайта
                      </p>
                      <p style="font-family: 'Inter Tight', Ubuntu, Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px; text-align: center; color: #000; margin: 0; padding: 0">
                          Из формы ${this.formData?.name}

                      </p>
                    </td>
                </tr>
              </tbody>
          </table>
          `
    }
  },
  watch: {
    didFormLoad (didFormLoad) {
      if (didFormLoad) {
        this.clearUnexpectedCreditDefaults()
      }
    }
  },
  mounted () {
    this.emailData.to = this.$configProvider?.config?.['manager-emails']?.forms?.emails.find(item => item.id === +this.$route.query.form)?.emails?.join(', ') || ''
  },
  methods: {
    isCreditForm () {
      return this.typeId === this.$config?.app?.forms?.ids?.CALCULATOR_CREDIT
    },
    isCreditProductField (field) {
      return field?.formParamType?.code === 'product_list_custom' &&
        field?.formParamType?.name === 'Выберите кредит'
    },
    isCreditOfficeField (field) {
      return this.isCreditForm() && field?.formParamType?.name === 'Выберите офис для посещения'
    },
    shouldUseCreditDefault (field) {
      return !this.isCreditForm() || this.isCreditProductField(field)
    },
    fieldPlaceholder (field, fallback) {
      return field?.formParamType?.params?.placeholder || fallback
    },
    clearUnexpectedCreditDefaults () {
      if (!this.isCreditForm()) { return }

      this.fields.forEach((field, index) => {
        if (field?.formParamType?.code === 'product_list_custom' && !this.isCreditProductField(field)) {
          this.newForm.params[index].value = ''
        }
      })
    },
    async onSubmit () {
      const indexDefault = this.fields.findIndex(item => item.formParamType.code === 'product_list_custom')
      if (!this.newForm.params[indexDefault]?.value && this.formDefault) {
        this.newForm.params[indexDefault].value = this.formDefault
      }
      this.triggerValidate = true

      setTimeout(() => {
        this.triggerValidate = false
      }, 200)

      if (!this.canSubmit) { return }
      this.emailData = { ...this.emailData, ...this.$configProvider?.config?.['mails-env-options'], subject: this.formData?.name }
      for (const index in this.fields) {
        this.secondPartOfMail = this.secondPartOfMail + `
          <table style="width: 100%; border: none; margin: 0 0 20px; padding: 0; border-collapse: collapse; border-bottom: 1px solid #EAEAEA;">
              <tbody>
                  <tr>
                      <td style="padding: 0 0 20px; text-align: left;">
                        <p style="font-family: 'Inter Tight', Ubuntu, Helvetica, Arial, sans-serif; font-size: 14px; line-height: 20px; text-align: left; color: #898989; margin: 0; padding: 0">
                            ${this.fields[index].formParamType.name}
                        </p>
                        <p style="font-family: 'Inter Tight', Ubuntu, Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px; text-align: left; color: #000; margin: 0; padding: 0; font-weight: bold;">
                            ${this.fields[index].formParamType.name.includes('Файл') ? 'Прикреплены к письму' : (this.newForm.params.find(el => el.id === this.fields[index].id)).value}
                        </p>
                      </td>
                  </tr>      
              </tbody>
          </table>
          `
      }
      this.emailData.html = this.firstPartOfMail + this.secondPartOfMail + this.thirdPartOfMail
      await this.submit('test_form', undefined, undefined, false)
      await this.sendEmail()
    },
    async sendEmail () {
      const maxRetries = 5
      let attempts = 0
      this.encryptedData = CryptoJS.AES.encrypt(JSON.stringify(this.filesArr.length ? { ...this.emailData, file: this.filesArr } : this.emailData), 'b19b2026f891c8d314e1a372960568ba').toString()
      while (attempts < maxRetries) {
        attempts++
        try {
          const response = await fetch('/api/send-email', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: this.encryptedData
          })

          const result = await response.json()

          if (result.success) {
            this.$toast.success(result.message)
            return
          } else {
            console.error(`Попытка ${attempts}: ${result.message} ${result.error}`)
          }
        } catch (error) {
          console.error(`Попытка ${attempts}: ошибка запроса`, error)
        }
        if (attempts < maxRetries) {
          await new Promise(resolve => setTimeout(resolve, 1000))
        }
      }
    },
    customValidate (value) {
      if (!value) { return ['Выберите продукт или обращение'] }

      return []
    },
    removeFiles (key, index) {
      this.filesArr.splice(index, 1)
      this.fileFullData.splice(index, 1)
      delete this.filesWithTypes[key]
    },
    handleFileUploaad (event) {
      if (!event.target.files.length) { return }
      const newFile = event.target.files
      this.fileFullData.push(event.target.files[0])
      const maxSize = 20 * 1024 * 1024 // 32MB в байтах
      let totalSize = 0

      for (const file of this.fileFullData) {
        totalSize += file.size
      }
      if (totalSize > maxSize) {
        this.fileFullData.pop()
        this.$toast.warning('Общий объем файлов не должен превышать 20 Мб')
        return
      }
      for (const file of newFile) {
        const reader = new FileReader()
        reader.readAsDataURL(file)

        reader.onload = (e) => {
          this.filesWithTypes = {
            ...this.filesWithTypes,
            [e.target.result]: file.name.split('.').pop().toLowerCase()
          }
          this.filesArr.push({ path: e.target.result })
        }
      }
    }
  }
}
</script>

<style scoped>
.credit-office-notice {
  margin-bottom: 20px;
}
</style>
